import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { safeStorage } from '@/lib/utils';
import { en } from './en';
import { nl } from './nl';

export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'nl', label: 'Nederlands' },
] as const;

const stored = safeStorage.get<string>('af:lang');

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, nl: { translation: nl } },
  lng: stored === 'nl' ? 'nl' : 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLanguage(code: 'en' | 'nl') {
  safeStorage.set('af:lang', code);
  void i18n.changeLanguage(code);
  document.documentElement.lang = code;
}

export default i18n;
